var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{staticClass:"map",attrs:{"center":_vm.center,"zoom":_vm.zoom},on:{"click":_vm.clickMap}},_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"position":m.position},on:{"click":function($event){return _vm.clickMarker(m.position)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }